module.exports = __webpack_public_path__ + "static/16-550fb61e198a01895366a8994c45003d.jpg";